module.exports = __webpack_public_path__ + "static/media/Profile.288b911d.svg";